import { createFileRoute, redirect } from "@tanstack/react-router";

// `/settings` has no pane of its own — land on the first section, carrying the
// side chat's `?chat=` through so it survives the redirect.
export const Route = createFileRoute("/_workspace/settings/")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/settings/integrations", search });
  },
});
